import { apiClient } from "./client";

export const instanceAPI = {
    getInstnaceList() {
        return apiClient.get(`/instances`);
    },

    getInstance(instanceName) {
        return apiClient.get(`/v2/instances/${instanceName}`);
    },

    deleteInstance(instanceName, volume = true, port = true, vm = true, db = true, ad = true) {
        return apiClient.delete(`/v2/instances/${instanceName}`, {
            data: { volume, port, vm, db, ad }
        });
    },

    power(instance, action, msg = true, auto = true) {
        return apiClient.put(`/v2/instances/${instance}/power`, { action, msg, auto });
    },

    logoff(instance) {
        return apiClient.put(`/v2/instances/${instance}/logoff`);
    },

    internetOn(instanceName) {
        return apiClient.put(`/v2/instances/${instanceName}/internet`);
    },

    internetOff(instanceName) {
        return apiClient.delete(`/v2/instances/${instanceName}/internet`);
    },

    metadataUpdate(instanceName, userName, ouName) {
        return apiClient.put(`/v2/instances/${instanceName}/metadata`, { userName, ouName });
    },

    metadataClear(instanceName) {
        return apiClient.delete(`/v2/instances/${instanceName}/metadata`);
    }
};
